import { makeVar } from "@apollo/client";

import { DEFAULT_WHITELABEL_VALID_JR_STEPS } from "../../constants";
import { WhiteLaelStepEnum } from "../../types";

export const whiteLabelStep = makeVar(WhiteLaelStepEnum.ProjectSettings);
export const isDisabledWhiteLabelProjectTabs = makeVar(true);
export const whiteLabelJRStep = makeVar(0);
export const whiteLabelJRActive = makeVar(false);
export const whiteLabelJRStartModal = makeVar(false);
export const whiteLabelValidJRSteps = makeVar(
  DEFAULT_WHITELABEL_VALID_JR_STEPS
);

export const currentUserVar = makeVar<any | null>(null);
export const createNewEventSignal = makeVar(0);

export const isVerificationToastShowVar = makeVar<boolean>(false);
export const isEmailVerificationSentVar = makeVar<boolean>(false);
export const isDeleteAccountModalShowVar = makeVar<boolean>(false);
export const isCancelSubscriptionModalShowVar = makeVar<boolean>(false);
export const promotionCurrentStepVar = makeVar<number>(1);
export const isEventCreatedAlertVisibleVar = makeVar<boolean>(false);
export const emailVerifyCreateEventModalVar = makeVar<boolean>(false);
export const notificationVerifyEmailModalVar = makeVar<boolean>(false);

export const eventStatusModalVar = makeVar<{ status: string; eventId: number } | null>(null);
export const stopTicketsSaleModalVar = makeVar<number | null>(null);
export const resumeTicketsSaleModalVar = makeVar<number | null>(null);
export const archiveModalVar = makeVar<number | null>(null);
export const createCopyModalVar = makeVar<number | null>(null);
export const attetionModalVar = makeVar<string | null>(null);

export interface IShareEventData {
  title: string;
  date: string;
  url: string;
}

export const isShareEventModalVar = makeVar<IShareEventData | null>(null);

export const whiteLabelLimitModalVar = makeVar<"free" | "pro" | null>(null);
export const isAccessModalVar = makeVar<boolean>(false);
export const unlockWhiteLabelModalVar = makeVar<boolean>(false);

export interface RevokeAccessModalState {
  userShareId: number;
  onConfirm: () => Promise<void>;
}

export const revokeAccessModalVar = makeVar<RevokeAccessModalState | null>(
  null
);
